import React, {MouseEventHandler} from 'react'
import styles from './styles.module.scss'

type ToggleProps = {
  value?: boolean,
  onClick?: MouseEventHandler<HTMLDivElement>
}

export const Toggle: React.FC<ToggleProps> = ({value, onClick}) => {
  return (
    <div onClick={onClick} className={`${styles.toggle} ${value ? styles.toggle_active : ''}`}>
      <div className={`${styles.toggle__circle} ${value ? styles.toggle__circle_active : ''}`} />
    </div>
  )
}